import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './LinkBlocks.module.scss';
import { Image } from '@outdoor-voices/ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

var LinkBlock = function LinkBlock(_ref) {
  var description = _ref.description,
      image = _ref.image,
      title = _ref.title,
      url = _ref.url;
  var src = image.src,
      alt = image.alt,
      height = image.height,
      width = image.width;
  return /*#__PURE__*/_jsxs("a", {
    className: css.link,
    href: url,
    children: [/*#__PURE__*/_jsx(Image, {
      src: src,
      alt: alt,
      height: height,
      width: width
    }), /*#__PURE__*/_jsx("h5", {
      className: css.title,
      children: title
    }), /*#__PURE__*/_jsx("p", {
      className: css.copy,
      children: description
    })]
  });
};

LinkBlock.propTypes = {
  description: PropTypes.string.isRequired,
  image: PropTypes.shape().isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

var LinkBlocks = function LinkBlocks(_ref2) {
  var center = _ref2.center,
      items = _ref2.items;
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("h4", {
      className: cc([css.header, _defineProperty({}, css.center, center)]),
      children: "#DoingThings"
    }), /*#__PURE__*/_jsx("div", {
      className: css.content,
      children: items.map(function (item) {
        return /*#__PURE__*/_createElement(LinkBlock, _objectSpread(_objectSpread({}, item), {}, {
          key: "block-".concat(item.id)
        }));
      })
    })]
  });
};

LinkBlocks.propTypes = {
  center: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
LinkBlocks.defaultProps = {
  center: false
};
export default LinkBlocks;